import React, { useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";
import axios from "axios";
// import * as ReactBootStrap from "react-bootstrap";
import { Aperture } from "lucide-react";
import SignatureContainer from "./SignatureContainer";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "./LoadingOverlay";
import toast from "react-hot-toast";

function Capture() {
  const navigate = useNavigate();

  const navigateToHome = (accessRequestId) => {
    navigate(`/Home?accessRequestId=${accessRequestId}`);
  };
  const [cardData, setCardData] = useState({
    cropped_sign: "",
    Document_type: "",
    account_no: "",
    holdername: "",
    ifsc_code: "",
  });
  const webcamRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false); // New state to control the loader
  const [capturedImage, setCapturedImage] = useState(null);
  const [showRemark, setShowRemark] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);
  const [ipAddress, setIpAddress] = useState("");

  useEffect(() => {
    if (cardData.cropped_sign) {
      setCroppedImage(cardData.cropped_sign);
    }
    if (cardData.status === 1) {
      const accessRequestId = cardData.accessRequestId; // Assuming the accessRequestId is available in cardData
      navigateToHome(accessRequestId);
      fetchIpAddress();
    }
  }, [cardData]);

  const captureImage = async () => {
    setShowLoader(true);
    setLoading(true);
    const imageSrc = webcamRef.current.getScreenshot();
    const compressedImageSrc = await compressImage(imageSrc, 0.8); // Compress by 80%
    setCapturedImage(compressedImageSrc);
    setShowLoader(false);
    setLoading(false);
  };

  const compressImage = (imageSrc, compressionFactor) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const newWidth = image.width * compressionFactor;
        const newHeight = image.height * compressionFactor;

        canvas.width = newWidth;
        canvas.height = newHeight;

        ctx.drawImage(image, 0, 0, newWidth, newHeight);
        const compressedImageSrc = canvas.toDataURL("image/jpeg");
        resolve(compressedImageSrc);
      };
      image.onerror = (error) => {
        reject(error);
      };
    });
  };

  const fetchIpAddress = async () => {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      setIpAddress(response.data.ip);
    } catch (error) {
      console.error('Error fetching the IP address:', error);
    }
  };

  const sendImageToAPI = async (base64String) => {
    await fetchIpAddress();

    try {
      // Prepare the API request
      const base64Stringe = `b'${base64String}'`;
      const formData = new FormData();
      formData.append("image", base64Stringe);
      const config = {
        method: "post",
        // url: `https://vumjbhw69h.execute-api.ap-south-1.amazonaws.com/default/signaturevalidate?Isdigital=0&IsSdk=1`,
        headers: {
          "x-api-key": "2gsYbi3yKC2lvXxp25o9z4w39DL6RIJS299E5j4N",
          "authorizationToken": "ix7L30Ml68S33Vme"
        },
        data: formData,
      };

      // Send the API request
      const response = await axios(config);
      setCardData(response.data);
      setShowRemark(true);
      if (response.data.status !== 1) {
        toast.error(response.data.remark);
      }

      if (response.data.status === 1) {
        toast.success("Valid Sign");  
        setTimeout(() => {
          const message = {
            accessRequestId: response.data.accessRequestId,
            signature_status: response.data.signature_status,
            ipAddress: ipAddress,
          };
          window.parent.postMessage(message, "*");
        }, 500);
      }  
    } catch (error) {
      toast.error("Something went wrong with the server");
    }
  };

  const handleSendButtonClick = async () => {
    setShowLoader(true);
    setLoading(true);

    try {
      const compressedBase64String = capturedImage.replace("data:image/jpeg;base64,", "");
      sendImageToAPI(compressedBase64String);
    } catch (error) {
      console.error("Error compressing image:", error);
      setShowLoader(false);
      setLoading(false);
    }
  };

  const retryCapture = () => {
    setCardData({
      cropped_sign: "",
      Document_type: "",
      account_no: "",
      holdername: "",
      ifsc_code: "",
    });
    setCapturedImage(null); // Reset the capturedImage state to null
    setShowRemark(false);
    setShowLoader(false); // Hide the loader when retrying capture
  };

  return (
    <SignatureContainer
    className='hide-on-desktop'
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {!cardData.cropped_sign ? (
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "60%",
            // height: "100%",
            overflow: "hidden",
            borderRadius: "16px",
            border: "1px solid #666",
            backgroundImage:
              "linear-gradient(140deg, rgb(255, 255, 255) 0%, rgb(230, 241, 254) 100%)",
            margin: "0 auto",
          }}
        >
          {showLoader ? (
            <div
              style={{
                width: "80%",
                height: "60%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LoadingOverlay />
            </div>
          ) : capturedImage ? (
            <div
              style={{
                textAlign: "center",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  position: "absolute",
                  borderRadius: "8px",
                  padding: "4px 20px",
                  border: "none",
                  cursor: "pointer",
                  background: "#0085ff",
                  color: "#fff",
                  right: "5px",
                  top: "5px",
                }}
                className="btn"
                onClick={retryCapture}
                // disabled={!isImageSelected}
              >
                Reset
              </button>

              <img
                src={capturedImage}
                alt="Captured Imgage"
                style={{ width: "100%", height: "auto" }}
              />
              {cardData.status && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <button
                    style={{
                      padding: "10px 20px",
                      fontSize: "16px",
                      borderRadius: "4px",
                      background: "#0085ff",
                      color: "#fff",
                      border: "none",
                    }}
                    onClick={retryCapture}
                  >
                    Retry Capture
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div
              style={{ width: "100%", height: "100%", position: "relative" }}
            >
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  facingMode: "environment", // Use the back camera by default
                }}
                style={{ width: "100%", height: "100%", touchAction: "none" }}
              />
             

              <button
                onClick={captureImage}
                style={{
                  position: "absolute",
                  bottom: "10px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  zIndex: 9999,
                }}
              >
                <Aperture size={48} color="#e7e7ee" strokeWidth={1.0} />
              </button>
            </div>
            
          )}
          {capturedImage && !showLoader && (
            <button
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                borderRadius: "8px",
                background: "#0085ff",
                color: "#fff",
                border: "none",
                position: "absolute",
                bottom: "10px",
              }}
              className="btn"

              onClick={handleSendButtonClick}
            >
              Save & Submit
            </button>
          )}
          
        </div>
        
      ) : (
        <><div style={{ position: "relative" }}>
            <img
              src={`data:image/png;base64,${cardData.cropped_sign}`}
              alt="Cropped Sign"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                border: "1px solid #0085ff",
                borderRadius: "16px",
                width: "100%",
                height: "100%"
              }} />

            <button
              style={{
                position: "absolute",
                borderRadius: "8px",
                padding: "6px 20px",
                border: "none",
                cursor: "pointer",
                background: "#0085ff",
                color: "#fff",
                right: "5px",
                top: "5px",
              }}
              className="btn"
              onClick={retryCapture}
            >
              Retake
            </button>
          </div></>
      )}
   
   

      {/* {cardData.status === 1 (
          navigateToHome()
        )} */}
       
       
        <div className="submit-button-container bottomCaptureNowBtn">
          {loading ? (
            <button
              className="btn"
              onClick={sendImageToAPI}
              // disabled={!isSignatureDrawn}
            >
            Continue ⚡
            </button>
          ) : (
            ""
          )}
          
      </div>
      
  
    
    </SignatureContainer>
    
  );
}

export default Capture;
